var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useState } from 'react';
import useTranslate from '../../../../localization/helpers';
var DeleteDocumentDialog = function (_a) {
    var open = _a.open, isLoading = _a.isLoading, onClose = _a.onClose, onDelete = _a.onDelete, options = _a.options, onSelectionChange = _a.onSelectionChange;
    var theme = useTheme();
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var _b = useTranslate(), translate = _b.translate, tWithFunction = _b.tWithFunction;
    var _c = __read(useState([]), 2), selectedOptions = _c[0], setSelectedOptions = _c[1];
    var handleSelectionChange = function (_, newValue) {
        setSelectedOptions(newValue);
        onSelectionChange(newValue.map(function (option) { return option.id; }));
    };
    var closeDialog = function () {
        setSelectedOptions([]);
        onClose();
    };
    var deleteDocument = function () {
        onDelete();
        closeDialog();
    };
    return (_jsxs(Dialog, { open: open, onClose: closeDialog, maxWidth: 'xs', fullWidth: true, children: [_jsx(DialogTitle, { children: tWithFunction('actions.deleteFunction', 'common.document') }), _jsx(DialogContent, { children: _jsxs(Stack, { spacing: 2, children: [_jsx(Typography, { variant: 'body1', children: tWithFunction('actions.deleteConfirmFunction', 'common.knowledge') }), options && options.length > 1 && (_jsx(Autocomplete, { noOptionsText: translate('common.noOptions'), multiple: true, disabled: isLoading, options: options, getOptionLabel: function (option) { return option.name; }, limitTags: 1, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, disableCloseOnSelect: true, value: selectedOptions.filter(function (option) { return options.some(function (o) { return o.id === option.id; }); }), onChange: handleSelectionChange, renderOption: function (props, option, _a) {
                                var selected = _a.selected;
                                return (_createElement("li", __assign({}, props, { key: option.id }),
                                    _jsx(Checkbox, { style: { marginRight: 8 }, checked: selected }),
                                    option.name));
                            }, renderInput: function (params) { return _jsx(TextField, __assign({}, params, { label: translate('common.assets') })); }, slotProps: {
                                paper: {
                                    sx: { maxHeight: isXs ? '150px' : '250px', overflowY: 'auto' }
                                }
                            } }))] }) }), _jsx(DialogActions, { children: _jsxs(Stack, { direction: 'row', spacing: 1, justifyContent: 'flex-end', width: '100%', children: [_jsx(Button, { onClick: closeDialog, variant: 'outlined', color: 'inherit', children: translate('actions.cancel') }), _jsx(Button, { onClick: deleteDocument, color: 'error', variant: 'contained', disabled: options && options.length > 1 && selectedOptions.length === 0, children: translate('actions.delete') })] }) })] }));
};
export default DeleteDocumentDialog;
